module.exports = __webpack_public_path__ + "static/img/cq101s.24c1d1bd.png";